import { render, staticRenderFns } from "./NewBookingSummarySidebar.vue?vue&type=template&id=00372859"
import script from "./NewBookingSummarySidebar.vue?vue&type=script&lang=js"
export * from "./NewBookingSummarySidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports